import { createFileRoute } from "@tanstack/react-router";
import ProductHubList from "@/pages/ProductHubList";

export const Route = createFileRoute("/generators/reviews")({
  component: () => <ProductHubList hubSlug="generators" variant="reviews" />,
});
